import React from "react";
import { ContentType } from "@utility/constants";
import VideoPost from "./VideoPost";
import ImagePost from "./ImagePost";
import DrawingPost from "./DrawingPost";
import TextPost from "./TextPost";

export default function Post({ post }) {
  /// Post component used to check the content type of the post to render the correct post component ///
  return (
    <>
      {post?.contentType === ContentType.IMAGE && <ImagePost post={post} />}
      {post?.contentType === ContentType.VIDEO && <VideoPost post={post} />}
      {post?.contentType === ContentType.DRAWING && <DrawingPost post={post} />}
      {post?.contentType === ContentType.TEXT && <TextPost post={post} />}
    </>
  );
}
